import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import CustomButton from "./CustomButton";
import { BsQuestionCircle } from "react-icons/bs";

function ConfirmDelete({ open, text, onClose, title, onSubmit, paragrap }) {
  const [buttonDisabled, setButtonDisabled] = useState(false);

  return (
    <Modal show={open} centered onHide={onClose}>
      {/* <Modal.Header closeButton>
        <div>ຢືນຢັນການລຶບ</div>
      </Modal.Header> */}
      <Modal.Body
        style={{
          padding: "4em",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%", heght: "50em"
        }}>
        <BsQuestionCircle color="#F75D59" size={80} />
        <br />
        <h5>{paragrap}</h5>
      </Modal.Body>
      <Modal.Footer
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <CustomButton
          title="ຍົກເລີກ"
          color="#3058A6"
          // icon={<HighlightOffOutlinedIcon />}
          width="150px"
          border="1px solid #EEEEEE"
          borderRadius="8px"
          onClick={onClose}
          background="#F1F1F1"
        />
        <div style={{ width: 24 }} />
        <CustomButton
          disabled={buttonDisabled}
          title={title}
          width="150px"
          borderRadius="8px"
          background="#D82C0D"
          onClick={() => {
            setButtonDisabled(true);
            onSubmit().then(() => setButtonDisabled(false));
          }}
        />
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmDelete;
